module.exports = __webpack_public_path__ + "static/img/my_trainings.e488fa7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/my_trainings.svg
// module id = 563
// module chunks = 0